export const View = {
  GRID: "grid",
  LIST: "list"
};
  